const DISMISS_KEY = "yunshu.phone_bind_nudge_dismissed";

export function isPhoneBindNudgeDismissed(): boolean {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissPhoneBindNudge() {
  try {
    sessionStorage.setItem(DISMISS_KEY, "1");
  } catch {
    /* ignore */
  }
}

/** 新登录 / 退出时清除，保证下次登录再弹 */
export function clearPhoneBindNudgeDismiss() {
  try {
    sessionStorage.removeItem(DISMISS_KEY);
  } catch {
    /* ignore */
  }
}
